export default __webpack_public_path__ + "b8fe27e6f86fa34c569ca1156c432a32.svg";